import React, {Component} from 'react';
import Main from '../Main';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {setLoadingPostRole, postRole, postRoleSuccess, postRoleError} from '../../actions/RoleActions';
import { path_roles } from '../../routes/Pathnames';
import {Link} from 'react-router-dom';
import {TRANSLATE_SAVE, TRANSLATE_CREATE_ROLE, TRANSLATE_ROLE_NAME, TRANSLATE_CANCEL} from '../../translates/Translates'; 

class CreateRole extends Component{
    constructor(props){
        super(props);

        this.state = {
            form: {
                name: '',
            },
        }
    }

    onChangeField = (event) => {
        const value = event.target.value;
        this.setState((prevState) => {
            let form = {...prevState.form};
            form.name = value;
            return {
                ...prevState,
                form
            }
        })
    }

    deleteForm = () => {
        this.setState((prevState) => {
            return {
                ...prevState,
                form: {
                    name: '',
                }
            }
        })
    }

    submitForm = (userData) => {
        this.props.setLoadingPostRole();
        this.props.postRole(userData).then((response) => {
            this.deleteForm();
            this.props.postRoleSuccess();
        }).catch(() => {
            this.props.postRoleError();
        })
    }

    render(){
        return(
            <div>
                <Main/>
                <div className="page-wrapper">
                    <div className="container-fluid">
                        <br />
                        <div className="row page-tier3">
                            <div className="col s12">
                                <div className="card card-outline-info">
                                    <div className="card-header">
                                        <h4 className="mb-0 text-white">{TRANSLATE_CREATE_ROLE}</h4>
                                    </div>
                                    <div className="card-body">
                                        <form method="post"> 
                                            <div className="form-body">
                                                <div className="row pt-3">
                                                    <div className="col-md-6">
                                                        <div className="form-group">
                                                            <label className="control-label">{TRANSLATE_ROLE_NAME}</label>
                                                            <input type="text" id="name" name="name" className="form-control" value={this.state.form.name} onChange={this.onChangeField} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6"></div>
                                                </div>
                                            </div>
                                            <div className="form-actions">
                                                <button type="button" className="btn btn-success mr-3" onClick={() => this.submitForm(this.state.form)}> 
                                                    <i className="fa fa-check"></i>&nbsp;{TRANSLATE_SAVE}
                                                </button>
                                                <Link to={path_roles} className="btn btn-inverse" >{TRANSLATE_CANCEL}</Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setLoadingPostRole,
        postRole,
        postRoleSuccess,
        postRoleError,
    }, dispatch);
}

export default connect(null, mapDispatchToProps)(CreateRole);
